<div class="table-responsive">
  <ng-container *ngIf="msg.data | guardType: isIBHandled as ib">
    <h6 class="small mb-0">IB Queue Handled Calls</h6>
    <table class="table table-sm table-bordered table-striped extra-small mb-0">
      <thead class="thead-dark">
        <tr>
          <th>Group</th>
          <th class="text-right">Handled</th>
          <th class="text-right">Abn</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let call of ib.handledCalls">
          <tr *ngIf="call.group !== 'Total'">
            <td>
              {{ call.group }}
            </td>
            <td class="text-right">{{ call.handled }}</td>
            <td class="text-right">
              {{ call.abn }}
            </td>
          </tr>
          <tr *ngIf="call.group === 'Total'" class="table-secondary total-row">
            <td>Total</td>
            <td class="text-right">
              {{ call.handled }}
            </td>
            <td class="text-right">
              {{ call.abn }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>
</div>
